// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"1a42e75e","59":"b3355151","136":"2b26e20d","509":"ad28448c","593":"6c3f79c6"}[chunkId] + ".chunk.js";
};